export default __webpack_public_path__ + "static/media/f5.e5f26119.jpg";